<app-modal id="add-wish">
  <div class="modal-content">
    <p class="title">Regarder cette recette plus tard ?</p>
    <p>Connectez-vous pour ajouter la recette à vos favoris.</p>
  </div>
  <div class="modal-btn">
    <button type="button" class="link" (click)="closeModal('add-wish');">Fermer</button>
    <a class="link-main" (click)="closeModalLogin('add-wish');" [routerLink]="'/connexion'">Se connecter</a>
  </div>
</app-modal>

<div class="bloc-filter">
  <div class="recipe-populare">
    <img src="/assets/images/recipe/list/icon-list-recipe.svg?v=2" alt="Picture {{form.get('order').value}}">
    <h2 [ngSwitch]="order" *ngIf="!forceTextFilter">
      <span *ngSwitchCase="'id,desc'">Nouveautés</span>
      <span *ngSwitchCase="'rate,desc'">Les mieux notées</span>
      <span *ngSwitchCase="'difficulty,asc'">Recettes Faciles</span>
      <span *ngSwitchCase="'difficulty,desc'">Recettes Difficiles</span>
      <span *ngSwitchDefault>Recettes Populaires</span>
    </h2>
    <h2 *ngIf="forceTextFilter">
      <span>{{forceTextFilter}}</span>
    </h2>
  </div>
  <app-recipe-order-by-component [defaultValue]="order" (eventOrder)="order = $event"></app-recipe-order-by-component>
</div>

<div class="loader-long" *ngIf="(dataSource | async).length == 0 && (isLoading | async)">
  <app-loader-component [bgColor]="bgColor"></app-loader-component>
</div>

<div class="bloc-empty" *ngIf="(dataSource | async).length == 0 && !(isLoading | async)">
  Il n'y a aucune recette disponible
</div>

<div #recipeListCard class="{{(isLoading | async) ? 'loading' : ''}}" *ngIf="(dataSource | async).length != 0">
  <app-recipe-card-component class="list-recipes-list" *ngIf="dataSource | async as currentRecipes"
                             [currentUser]="currentUser" [currentRecipes]="currentRecipes"></app-recipe-card-component>

  <div class="pagination">
    <ng-container *ngIf="(totalItems | async) > (pageSize | async)">
      <div *ngFor="let page of getPagination(currentPage | async, totalItems | async, pageSize | async)"
           class="pagination-item {{page == (+(currentPage | async) + 1) ? 'current-page' : ''}} {{page == '...'? '' : 'clickable'}}"
           (click)="loadPageWithEvent(page, sizePage)">
        <span>{{page}}</span>
      </div>
    </ng-container>
  </div>
</div>



